<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Alíquota ISS</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('municipioiss.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('municipioiss.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('municipioiss.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'param_banco'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/municipioiss"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="muniss_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                    detail-row-component="municipio-iss-detalhes"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('municipioiss.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <span v-if="getPermissionFw('municipioiss.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                        <a
                          @click="onCreateVigencia(props.rowData)"
                          v-b-tooltip
                          title="Vincular vigencia"
                          ><i class="fa fa-calendar"></i
                        ></a>
                        <a
                          v-if="props.rowData.municipio_iss_vigencia.length > 0"
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MunicipioIssForm
        ref="municipioissform"
        :metodo="onReloadData"
        :tabela="'municipio_iss'"
        :rota="'municipioiss'"
      >
      </MunicipioIssForm>
      <MunicipioIssVigenciaForm
        ref="municipioissvigenciaform"
        :metodo="onReloadData"
        :tabela="'municipio_iss_vigencia'"
        :rota="'municipioissvigencia'"
      />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MunicipioIssFilterBar from "./MunicipioIssFilterBar";
import MunicipioIssForm from "./MunicipioIssForm";
import MunicipioIssDetalhes from "./MunicipioIssDetalhes.vue";
import MunicipioIssVigenciaForm from "./MunicipioIssVigenciaForm.vue";
Vue.component("municipio-iss-detalhes", MunicipioIssDetalhes);
export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    MunicipioIssForm,
    MunicipioIssVigenciaForm,
    "vuetable-filterbar": MunicipioIssFilterBar
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: "", descr: "", muniss_id: "", status: [] }),
      helpForm: new Form({ statusRecord: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "municipio.nome",
          title: "Municipio"
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status"
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
  },
  methods: {
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.muniss_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        status: data_filter.status.value,
        municipio_id: data_filter.municipio.value
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onReloadData() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.municipioissform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.muniss_id;
      this.$refs.municipioissform.onEdit(data, index, this.id);
    },
    onCreateVigencia(data) {
      this.$refs.municipioissvigenciaform.onCreate(data);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.muniss_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.municipioissform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      }
    }
  }
};
</script>
